import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../ReportCategory";
import DividendPayableWriteUpReportCriteria from "./DividendPayableWriteUpReportCriteria";
import { AppService, DomainTypes } from "../../../Domain/DomainTypes";

@NeoReport("DividendPayableWriteUp", { category: ReportCategory.InvestorReports })
export default class DividendPayableWriteUpReport extends Report<DividendPayableWriteUpReportCriteria> {

    constructor(private dataCache = AppService.get(DomainTypes.Services.DataCache)) {
        super(DividendPayableWriteUpReportCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.GridLayout md={2}>
                <Neo.FormGroup bind={this.criteria.meta.endDate} />
                <Neo.FormGroup bind={this.criteria.meta.entityId}
                               select={{itemSource: this.dataCache.entities, filterPredicate(item) { return !item.hasVestingTrust; }}} />
            </Neo.GridLayout>
        </div>;
    }
}